<template>
<div class="header">
  <div class="leftImg">
<!--    <van-icon name="arrow-left" @click="$router.back()" />-->
    <img src="/static/image/new/game/back.png" @click="$router.back()" alt="">
  </div>
  <span class="head_text">{{ title }}</span>
  <span class="right_menu"></span>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: relative;
  z-index: 2;
  height: 1.33333rem;
  display: flex;
  align-items: center;
  padding: 0 .4rem;
  flex-shrink: 0;
  .leftImg {
    flex: 1;
    text-align: left;
    //font-size: .48rem;
    img {
      width: 1rem;
    }
  }
  .top_back {
    width: 0.26rem;
    height: 0.37333rem;
  }
  .head_text {
    font-size: 0.48rem;
    color: #fff;
    width: 55%;
    text-align: center;
  }
  .right_menu {
    font-size: 0.37333rem;
    color: #fff;
    flex: 1;
    text-align: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/header.vue